<template>
  <div>
   <div>
      <div class="VueCarousel-slide active" ref="story1">
        <div class="padding">
          <div>
            <p></p>
            <p> &nbsp;</p>
            <p> The changes come faster by the day, there's a storm coming, in the air,</p><br>
            <p> unknown architectures continue to appear around me</p><br>
            <p> a road runs where yesterday there was only water</p><br>
            <p> my maps and documents are all fiction</p><br>
            <p> &nbsp;</p>
            <p> I begin to write again</p><br>
            <p> This time I start with your name</p><br>
            <p> &nbsp;</p>
            <p> I hope there is still time</p><br>
            <p> &nbsp;</p>
              <p>I remember when he was a baby, when he first reached out with his hands and we called him a bear.
              He was never Oska then, he was bear, and I even stopped calling him by his name for a few months. I remember that, I know that voice was mine and the child was ours and I know that I loved you. </p><br>
              <p>I remember his first smile, the moment a tottering step gave way to a series and then to a walk. I remember the smile that creased across his face when he reached you, across that room. You were sat in the sunlight, it caught your hair and set fire to your cheeks and you loved him too. </p><br>
              <p>I remember the day we parted, </p><br>
              <p>I remember walking between two worlds and losing you. </p><br>
              <p> &nbsp;</p>
               </div>
        </div>
      </div>
      <div class="VueCarousel-slide hidden" ref="story2">
        <div class="padding">
          <div>
            <span class="arch">
              <p>I thought I was mad. </p><br>
              <p>I rewrote my memories every time I recalled something, made each moment more intense, less reliable, less useful to me.</p><br>
              <p>Then, in her words, I saw the world, the worlds, more clearly. </p><br>
              <p> &nbsp;</p>
              <p>I've seen two cities merging,
              two skylines becoming one and I see the water rising and carving a harbour where there is not. </p><br>
              <p>This cannot hold, the two cannot become the same place here, nor there,
              this one is just an echo</p><br>
              <p>I know that now</p><br>
              <p>a city will fall, these pages joining it like ash, </p><br>
              <p> &nbsp;</p>
              <p>I've searched for a way,</p><br>
              <p>for a path, maybe even a door</p><br>
              <p>it seems so foolish now</p><br>
              <p>and in my search i found only failure</p><br>
              <p>I tried to tell those around me, </p><br>
              <p>and of course they laugh and point and joke,</p><br>
              <p>they thought I was mad</p><br>
              <p>I become the fool, </p><br>
              <p>somehow even I laugh now,</p><br>
              <p> &nbsp;</p>
              <p>Now I watch them pass, i watch their smiles,</p><br>
              <p>and I am jealous of their ignorance,</p><br>
              <p>and yet I still want them to know,</p><br>
              <p>how easily this will all be forgotten,</p><br>
              <p>how these fragile moments beat like moth wings</p><br>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p>To assume another identity, to wear this new life as a fiction. </p><br>
              <p>It would seem to be the simpler solution, wouldn't it? </p><br>
              <p>To drift amongst strangers in a fading sea</p><br>
              <p>I would at least be sure of where I was. </p><br>
              <p> &nbsp;</p>
              <p>And in what days are left, I could forget what I know</p><br>
              <p>these moments I remember could fade.</p><br>
              <p>and I would just wait for this echo to finish sounding out</p><br>
              <p> &nbsp;</p>

              <p>But this is not where I belong and I know that.</p><br>
              <p> &nbsp;</p>
              <p>She knows me and she knows how to write this. </p><br>
              <p>She has written so much, she transcribed a world into pages. </p><br>
              <p>If she draws that city as real, if she remembers it all clearly, fixes it,
              then there is somewhere for a part of me to live,</p><br>
              <p>even if only in her memory.</p><br>
              <p> &nbsp;</p>
              <p>if I can be that to her, </p><br>
              <p>then maybe I need not care about the coming silence,</p><br>
              <p>about what happens here,</p><br>
              <p>about what's left of me in a city she cannot see.</p><br>
              <p>but this choice is not mine to make</p><br>
              <p> &nbsp;</p>
              <p>so now </p><br>
              <p>here, </p><br>
              <p>in the softest place I could find</p><br>
              <p> &nbsp;</p>
              <p>the most simple</p><br>
              <p> &nbsp;</p>
              <p>i just wait </p><br>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
              <p> &nbsp;</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'Mothwings'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
